import { render } from "./CardDeFiltros.vue?vue&type=template&id=034229c0&scoped=true&ts=true"
import script from "./CardDeFiltros.vue?vue&type=script&lang=ts"
export * from "./CardDeFiltros.vue?vue&type=script&lang=ts"

import "./CardDeFiltros.vue?vue&type=style&index=0&id=034229c0&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034229c0"]])

export default __exports__